<div>
  <form class="" role="form" [formGroup]="form">
    <select class="input-group-addon no-image page-size-select" (change)="changeFilterOption()" formControlName="filterOption">
      <option *ngFor="let filterOption of filterOptions" [value]="filterOption.value">{{filterOption.label}}</option>
    </select>
  </form>
</div>
